// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "attachment-title-editor{display:block;position:relative;padding:10px}attachment-title-editor .glyphicons-pencil{display:block;position:absolute;top:10px;left:10px}attachment-title-editor .input-borderless{width:100%;padding-left:20px !important}", ""]);
// Exports
module.exports = exports;
